import capitalizeFirstLetter from './capitalizeFirstLetter';

export default function capitalizeWords(text: string) {
    const words = text.split(' ');
    const capitalizedWords = words.map(word => capitalizeFirstLetter(word));
    return capitalizedWords.join(' ');
}
